
  export const Areaconfig=[
    {
    "KP Siding (RD1603)": [
    "172.24.113.82",
    "172.24.113.83"
  ],
  "Tarmi Siding WB 02 (RD1602)": [
    "172.24.113.114"
  ],
  "AMLO SIDING WB 2 (RD1609)": [
    "172.24.114.11",
    "172.24.114.12"
  ],
  "OLD AMLO CHECKPOST EXIT (CP1232)": [
    "172.24.203.22",
    "172.24.203.27"
  ],
  "Amlo CP WB 3 (RD1612)": [
    "172.24.203.54",
    "172.24.203.55"
  ],
  "AMLO CHECKPOST WB 01 (RD1610 )": [
    "172.24.113.162",
    "172.24.113.163"
  ]
     
},

      //Piparwar
      {
  "ASHOKA ROAD WB 12 (RD1712 )": [
    "172.24.195.182",
    "172.24.195.183"
  ],
  "ASHOKA ROAD WB 14 (RD1714 )": [
    "172.24.195.150",
    "172.24.195.151"
  ],
  "ASHOKA WB 03 IN": [
    "170.20.13.122"
  ],
  "ASHOKA WB 03 OUT": [
    "170.20.13.123"
  ],
  "ASHOKA WB 09 (RD1709 )": [
    "172.24.195.102",
    "172.24.195.103"
  ],
  "ASHOKA WB 16 IN": [
    "170.20.13.127",
    "170.20.13.128",
    "170.20.13.129"
  ],
  "ASHOKA WB 16 OUT": [
    "170.20.13.126"
  ],
  "ASHOKA WORKSHOP -2": [
    "170.20.13.39"
  ],
  "Amarpali to CHP CPP checkpost ENTRY (CP1341 )": [
    "172.24.190.150",
    "172.24.190.151"
  ],
  "Amarpali to CHP CPP checkpost EXIT (CP1342 )": [
    "172.24.190.156",
    "172.24.190.157"
  ],
  "Amrapali Checkpost": [
    "170.20.13.231",
    "170.20.13.232"
  ],
  "Ashoka Rajdhar Checkpost EXIT (CP1332 )": [
    "172.24.190.134",
    "172.24.190.135"
  ],
  "Ashoka Rajdhar Checkpost Entry (Ashoka Rajdhar Checkpost Entry (CP1331 ) )": [
    "172.24.190.140",
    "172.24.190.141"
  ],
  "Ashoka Road WB 03 (RD1703 )": [
    "172.24.195.38",
    "172.24.195.39"
  ],
  "Ashoka Road WB 08 (RD1708 )": [
    "172.24.195.77",
    "172.24.195.78"
  ],
  "Ashoka Road WB 13 (RD1713 )": [
    "172.24.195.166",
    "172.24.195.167"
  ],
  "Ashoka Road WB 16 (RD1716 )": [
    "172.24.195.198",
    "172.24.195.199"
  ],
  "Ashoka WB 07 (RD1707 )": [
    "172.24.195.70",
    "172.24.195.71"
  ],
  "Ashoka Wb 08 In": [
    "170.20.13.77"
  ],
  "Ashoka Wb 08 Out": [
    "170.20.13.76"
  ],
  "Ashoka Wb 12 In": [
    "170.20.13.89"
  ],
  "Ashoka Wb 12 Out": [
    "170.20.13.88"
  ],
  "Ashoka Wb 13 In": [
    "170.20.13.47"
  ],
  "Ashoka Wb 13 Out": [
    "170.20.13.46"
  ],
  "BACHRA MAGZINE ROOM": [
    "170.20.13.221"
  ],
  "BS WB 01 (RD1723 )": [
    "172.24.190.86",
    "172.24.190.87"
  ],
  "CHP COAL PIT NEAR 1104": [
    "170.20.13.169"
  ],
  "CHP CONTROL ROOM": [
    "170.20.13.152"
  ],
  "CHP CONTROL ROOM PTZ": [
    "170.20.13.151"
  ],
  "CHP Control Room": [
    "170.20.13.159"
  ],
  "CHP GATE": [
    "170.20.13.156"
  ],
  "CHP PO OFFICE": [
    "170.20.13.155"
  ],
  "CHP WB 02 (RD1730 )": [
    "172.24.195.217",
    "172.24.195.222"
  ],
  "CHP WB 10 (RD0101 )": [
    "172.24.195.246",
    "172.24.195.247"
  ],
  "CHP WB 11 (RD1740 )": [
    "172.24.195.86",
    "172.24.195.87"
  ],
  "CHP Wb 01 IN": [
    "170.20.13.80"
  ],
  "CHP Wb 01 OUT": [
    "170.20.13.79"
  ],
  "CHP Wb 02 IN": [
    "170.20.13.82"
  ],
  "CHP Wb 02 Out": [
    "170.20.13.83"
  ],
  "CHP Wb 10 In": [
    "170.20.13.85"
  ],
  "CHP Wb 10 Out": [
    "170.20.13.86"
  ],
  "CHP Wb 11 in": [
    "170.20.13.164"
  ],
  "CHP Wb 11 out": [
    "170.20.13.163"
  ],
  "CHP checkpost near road wb12 ENTRY (CP1321 )": [
    "172.24.190.166",
    "172.24.190.167"
  ],
  "CHP checkpost near road wb12 EXIT (CP1322 )": [
    "172.24.190.173",
    "172.24.190.174"
  ],
  "Camera In": [
    "170.20.13.65",
    "170.20.13.91"
  ],
  "Camera Out": [
    "170.20.13.66",
    "170.20.13.92"
  ],
  "Doctor Waiting": [
    "170.20.13.57"
  ],
  "GM OFFICE MAIN GATE IN": [
    "170.20.13.242"
  ],
  "GM OFFICE MAIN GATE OUT": [
    "170.20.13.241"
  ],
  "GM UNIT Entrance": [
    "170.20.13.243"
  ],
  "GOLAMBAR CHECKPOST ENTRY (CP1311 )": [
    "172.24.190.182",
    "172.24.190.183"
  ],
  "GOLAMBAR CHECKPOST EXIT (CP1312 )": [
    "172.24.190.188",
    "172.24.190.189"
  ],
  "Gm Office Control Room Back": [
    "170.20.13.96"
  ],
  "Gm Office Control room Earting": [
    "170.20.13.94"
  ],
  "Gm Office Control room Ent": [
    "170.20.13.95"
  ],
  "Gm Office Control room Side Gate": [
    "170.20.13.93"
  ],
  "Hospital Main Gate": [
    "170.20.13.56"
  ],
  "Inside Room": [
    "170.20.13.186"
  ],
  "Lions  Club": [
    "170.20.13.31",
    "170.20.13.32",
    "170.20.13.33"
  ],
  "MAGZINE GATE 2": [
    "170.20.13.222"
  ],
  "PPR PO ROAD": [
    "170.20.13.189"
  ],
  "Panchwati": [
    "170.20.13.11"
  ],
  "RCM RAIL OUT": [
    "170.20.13.16"
  ],
  "RCM ROAD WB-11 (RD1711 )": [
    "172.24.195.118",
    "172.24.195.119"
  ],
  "Rajdhar Morcha 1": [
    "170.20.13.201",
    "170.20.13.202",
    "170.20.13.203"
  ],
  "Rajdhar Morcha 2 Coal Stock": [
    "170.20.13.207"
  ],
  "Rajdhar Siding BACK": [
    "170.20.13.198"
  ],
  "Rajdhar Siding CISF CHECK POST": [
    "170.20.13.199"
  ],
  "Rajdhar Siding Towards Siding": [
    "170.20.13.197"
  ],
  "Rajdhar Siding Towards WB": [
    "170.20.13.196"
  ],
  "Rajhdhar RL WB": [
    "170.20.13.206"
  ],
  "Ray Colliery": [
    "170.20.13.112",
    "170.20.13.113",
    "170.20.13.114",
    "170.20.13.115",
    "170.20.13.117",
    "170.20.13.118",
    "170.20.13.119"
  ],
  "Sampling Room Out": [
    "170.20.13.188"
  ],
  "Silo": [
    "170.20.13.158"
  ],
  "Sister Out": [
    "170.20.13.59"
  ],
  "Survey": [
    "170.20.13.170"
  ],
  "TO ENT": [
    "170.20.13.244"
  ],
  "Towards PO Room": [
    "170.20.13.187"
  ],
  "Unknown": [
    "170.20.13.148"
  ],
  "Ward": [
    "170.20.13.58"
  ]
},
//Hazaribgh
{ 
  "ELECTRONIC ROAD WB 1 (RD1401 )": [
    "172.24.58.23",
    "172.24.58.29"
  ],
  "Kedla Washery BRO WB-2 (RD1402 )": [
    "172.24.58.40",
    "172.24.58.45"
  ],
  "Chainpur Siding Weighbridge (RD1404 )": [
    "172.24.57.247",
    "172.24.57.250"
  ],
  "TAPIN NORTH ROAD SALE WB 2 (RD1411 )": [
    "172.24.197.6",
    "172.24.197.7"
  ],
  "TAPIN SOUTH WB 01 (RD1406 )": [
    "172.24.197.29",
    "172.24.197.30"
  ],
  "TAPIN NORTH WB 01 (RD1414 )": [
    "172.24.197.86",
    "172.24.197.87"
  ],
  "JHARKHAND OC WB 2 (RD1415 )": [
    "172.24.197.105",
    "172.24.197.106"
  ],
  "CHARHI SIDING ROAD WB (RD1418 )": [
    "172.24.197.214",
    "172.24.197.215"
  ],
  "Parej WB2 (RD1410 )": [
    "172.24.58.72",
    "172.24.58.73"
  ],
  "Kedla Washery Road Sale WB-3 (RD1403 )": [
    "172.24.58.155",
    "172.24.58.156"
  ],
  "KEDLA WASHERY CHECKPOST ENTRY (CP1022 )": [
    "172.24.129.122",
    "172.24.129.123"
  ],
  "KEDLA WASHERY CHECKPOST ENTRY (CP1021 )": [
    "172.24.129.124",
    "172.24.129.125"
  ],
  "Tapin North Checkpost Entry (CP1004 )": [
    "172.24.129.155",
    "172.24.129.156"
  ],
  "Tapin North Checkpost Entry (CP1003 )": [
    "172.24.129.157",
    "172.24.129.158"
  ],
  "Tapin south checkpost EXIT (CP1002 )": [
    "172.24.150.250",
    "172.24.150.251"
  ],
  "PAREJ ENTRY (CP1005 )": [
    "172.24.57.197",
    "172.24.57.198"
  ],
  "PAREJ EXIT (CP1006 )": [
    "172.24.57.211",
    "172.24.57.212"
  ],
  "Unknown": [
    "180.20.2.129",
    "180.20.2.160",
    "180.20.2.37",
    "180.20.2.45",
    "180.20.2.55",
    "180.20.2.61",
    "180.20.2.72",
    "180.20.2.73",
    "180.20.3.101",
    "180.20.3.102",
    "180.20.3.11",
    "180.20.3.133",
    "180.20.3.136",
    "180.20.3.137",
    "180.20.3.18",
    "180.20.3.19",
    "180.20.3.3",
    "180.20.3.4",
    "180.20.3.48",
    "180.20.3.58",
    "180.20.3.59",
    "180.20.3.63",
    "180.20.3.64",
    "180.20.3.65",
    "180.20.3.66",
    "180.20.3.67",
    "180.20.3.68",
    "180.20.3.71",
    "180.20.3.74",
    "180.20.3.75",
    "180.20.3.91",
    "180.20.6.130",
    "180.20.6.19",
    "180.20.6.28",
    "180.20.6.29",
    "180.20.6.32",
    "180.20.6.50",
    "180.20.6.51",
    "180.20.6.52",
    "180.20.7.104",
    "180.20.7.105",
    "180.20.7.106",
    "180.20.7.107",
    "180.20.7.108",
    "180.20.7.109",
    "180.20.7.253",
    "180.20.7.45",
    "180.20.7.59",
    "180.20.7.92",
    "180.20.7.93",
    "180.20.7.94"
  ],
  "Road Sale WB": [
    "180.20.7.46"
  ],
  "Kedla Washery Security Room": [
    "180.20.7.4",
    "180.20.7.5"
  ],
  "Kedla Washery Mart Room": [
    "180.20.7.6"
  ],
  "Kedla Washery PO Office": [
    "180.20.7.3"
  ],
  "Kedla Washery DDU": [
    "180.20.7.60",
    "180.20.7.61"
  ],
  "Kedla Washery Slurry Pond": [
    "180.20.7.55",
    "180.20.7.56",
    "180.20.7.57"
  ],
  "Kedla Washery Store": [
    "180.20.1.91"
  ],
  "Kedla Washery Road Sale WB": [
    "180.20.7.64"
  ],
  "IPC": [
    "180.20.2.48",
    "180.20.2.5",
    "180.20.2.56",
    "180.20.2.57",
    "180.20.2.58",
    "180.20.2.8",
    "180.20.6.13",
    "180.20.6.18",
    "180.20.6.4",
    "180.20.6.53",
    "180.20.6.7",
    "180.20.7.141",
    "180.20.7.146",
    "180.20.7.26"
  ],
  "Kedla Washery Road Sale IN": [
    "180.20.7.25"
  ],
  "Kedla Washery BRO WB": [
    "180.20.7.152"
  ],
  "45 KANTA CHECKPOST": [
    "180.20.1.231"
  ],
  "Tapin North Workshop": [
    "180.20.2.6"
  ],
  "Tapin North Biometric": [
    "180.20.2.7"
  ],
  "Tapin North PO Office": [
    "180.20.2.62"
  ],
  "Tapin North Coal Stock": [
    "180.20.2.128",
    "180.20.2.150",
    "180.20.2.151"
  ],
  "JOCP Pit Office": [
    "180.20.6.5"
  ],
  "JOCP WB3": [
    "180.20.6.55"
  ],
  "JOCP Diesel Point": [
    "180.20.6.20",
    "180.20.6.21"
  ],
  "Coal Stock 2": [
    "180.20.6.54"
  ],
  "JOCP Control Room": [
    "180.20.6.115"
  ]
},
//NK
{
"Rohini Weighbridge 1 (RD0610 )": [
    "172.24.194.6",
    "172.24.194.7"
  ],
  "Dakra WB 02 (RD0609 )": [
    "172.24.194.22",
    "172.24.194.23"
  ],
  "Dakra WB No 1 (RD0608 )": [
    "172.24.194.36",
    "172.24.194.38"
  ],
  "KDH ROAD WB No 2 (RD0606 )": [
    "172.24.194.70",
    "172.24.194.71"
  ],
  "CHURI ROAD WB (RD0601 )": [
    "172.24.194.102",
    "172.24.194.103"
  ],
  "Purnadih WB 01 (RD0602 )": [
    "172.24.194.134",
    "172.24.194.135"
  ],
  "Purnadih WB 2 (RD0603 )": [
    "172.24.194.150",
    "172.24.194.151"
  ],
  "Rohini Weighbridge 2 (RD0611 )": [
    "172.24.194.182",
    "172.24.194.183"
  ],
  "KDH WB 03 (RD0607 )": [
    "172.24.189.51",
    "172.24.189.55"
  ],
  "Dakra OCP Checkpost Entry (CP0353 )": [
    "172.24.189.194",
    "172.24.189.195"
  ],
  "Dakra OCP Checkpost Exit (CP0354 )": [
    "172.24.189.196",
    "172.24.189.197"
  ],
  "KDH CHECKPOST ENTRY (CP0351 )": [
    "172.24.189.230",
    "172.24.189.234"
  ],
  "KDH CHECKPOST EXIT (CP0352 )": [
    "172.24.189.236",
    "172.24.189.237"
  ]
},

//BarkaSayal
{
  "SAUNDA B 60 MT WB (RD0305 )": [
    "172.24.196.25",
    "172.24.196.26"
  ],
  "Saunda 50Mt New (RD0304 )": [
    "172.24.196.39",
    "172.24.196.40"
  ],
  "New Birsa 60 TON WB (RD0307 )": [
    "172.24.196.71",
    "172.24.196.72"
  ],
  "BHURKUNDA MINE B 50MT (RD0310 )": [
    "172.24.196.103",
    "172.24.196.104"
  ],
  "Urimari hesabeda road WB (RD0302 )": [
    "172.24.196.134",
    "172.24.196.135"
  ],
  "BIRSA HESABEDA 50TON WEIGHBRIDGE (RD0308 )": [
    "172.24.196.150",
    "172.24.196.151"
  ],
  "BURKUNDA EXIT CHECK POST (CP3022 )": [
    "172.24.196.235",
    "172.24.196.236"
  ],
  "BURKUNDA ENTRY CHECK POST (CP3021 )": [
    "172.24.196.237",
    "172.24.196.238"
  ],
  "Potanga Checkpost (CP0125 )": [
    "172.24.190.219",
    "172.24.190.220"
  ],
  "Potanga Checkpost Exit (CP0126 )": [
    "172.24.190.221",
    "172.24.190.222"
  ],
  "NEW BIRSA CHECKPOST EXIT (CP0112 )": [
    "172.24.190.235",
    "172.24.190.236"
  ],
  "NEW BIRSA CHECKPOST ENTRY (CP0111 )": [
    "172.24.190.237",
    "172.24.190.238"
  ],
  "Unknown": [
    "180.20.20.10",
    "180.20.20.11",
    "180.20.20.12",
    "180.20.20.121",
    "180.20.20.17",
    "180.20.20.173",
    "180.20.20.174",
    "180.20.20.18",
    "180.20.20.192",
    "180.20.20.26",
    "180.20.20.31",
    "180.20.20.35",
    "180.20.20.36",
    "180.20.20.45",
    "180.20.20.46",
    "180.20.30.19",
    "180.20.30.22",
    "180.20.30.25",
    "180.20.30.29"
  ],
  "KK MORE 50 MT ROAD WEIGHBRIDGE (RD0303)": [
    "172.24.196.10",
    "172.24.196.9"
  ],
  "POTANGA ROAD WEIGHBRIDGE (RD0301)": [
    "172.24.196.167",
    "172.24.196.168"
  ],
  "PSME ENPSME ENTRY (CP0121)": [
    "172.24.196.250"
  ],
  "PSME ENTRY (CP0121)": [
    "172.24.196.251"
  ],
  "PSME EXIT (CP0122)": [
    "172.24.196.252",
    "172.24.196.253"
  ],
  "SAYAL D 100MT WB (RD0311)": [
    "172.24.196.198"
  ],
  "BIRSA 100 RLY SIDING WEIGHBRIDGE (RD0319 )": [
    "172.24.196.218",
    "172.24.196.219"
  ],
  "SAYAL D 100MT WB (RD0311 )": [
    "172.24.196.202"
  ]

},

//Argada
{
  "ARGADA AREA RELIGARA WB 60 MT (RD0402 )": [
    "172.24.199.23",
    "172.24.199.24"
  ],
  "Giddi A EXIT GATE (CP3052 )": [
    "172.24.199.91",
    "172.24.199.92"
  ],
  "Giddi A ENTRY GATE (CP3051 )": [
    "172.24.199.93",
    "172.24.199.94"
  ],
  "Religara 100 Mt (RD0406 )": [
    "172.24.150.30"
  ],
  "Giddi A 60 MT (RD0405 )": [
    "172.24.199.7",
    "172.24.199.8"
  ],
  "GIDDI C 60 MT ELECTRONIC ROAD WB (RD0401 )": [
    "172.24.199.38",
    "172.24.199.39"
  ],
  "SIRKA ENTRY GATE (CP3005 )": [
    "172.24.199.75",
    "172.24.199.76"
  ],
  "SIRKA EXIT GATE (CP3006 )": [
    "172.24.199.77",
    "172.24.199.78"
  ],
  "Giddi C ENTRY GATE (CP3053 )": [
    "172.24.199.102"
  ],
  "Giddi C EXIT GATE (CP3054 )": [
    "172.24.199.104",
    "172.24.199.105"
  ],
  "ARGADA SIRKA ROAD WB (RD0403 )": [
    "172.24.199.51",
    "172.24.199.55"
  ],
  "CP No. 1 (Sadhu More)": [
    "172.18.0.16",
    "172.18.0.17",
    "172.18.0.18",
    "172.18.0.19"
  ],
  "WB+Coal Stock near Pump House": [
    "172.18.0.22",
    "172.18.0.23",
    "172.18.0.24",
    "172.18.0.25"
  ],
  "Sirka New Coal Stock": [
    "172.18.0.27",
    "172.18.0.28"
  ],
  "Excavation Workshop": [
    "172.18.0.34",
    "172.18.0.35",
    "172.18.0.77",
    "172.18.0.78",
    "172.18.0.79"
  ],
  "OCP Checkpost No. 2+Dumper Yard": [
    "172.18.0.37",
    "172.18.0.38",
    "172.18.0.39",
    "172.18.0.40"
  ],
  "Sirka Unit Store": [
    "172.18.0.231",
    "172.18.0.42",
    "172.18.0.43"
  ],
  "E&M W/shop": [
    "172.18.0.45",
    "172.18.0.46"
  ],
  "MTK Office": [
    "172.18.0.48",
    "172.18.0.49",
    "172.18.0.75"
  ],
  "Sirka PO Office": [
    "172.18.0.51",
    "172.18.0.52",
    "172.18.0.53"
  ],
  "WTP+ Pokharia": [
    "172.18.0.55",
    "172.18.0.56",
    "172.18.0.57",
    "172.18.0.58"
  ],
  "Argada Sub-station": [
    "172.18.0.60",
    "172.18.0.61"
  ],
  "Sirka Dispensary": [
    "172.18.0.72",
    "172.18.0.73"
  ],
  "Sirka Magazine": [
    "172.18.0.69",
    "172.18.0.70"
  ],
  "Tongi Sub Station": [
    "172.18.0.184",
    "172.18.0.185"
  ],
  "Checkpost - GiddiA": [
    "172.18.0.86",
    "172.18.0.87"
  ],
  "Giddi A WB": [
    "172.18.0.89",
    "172.18.0.90",
    "172.18.0.91",
    "172.18.0.92"
  ],
  "Giddi A Coal Stock": [
    "172.18.0.98",
    "172.18.0.99"
  ],
  "Magzine - Giddi A": [
    "172.18.0.104",
    "172.18.0.105"
  ],
  "Workshop + DDU (Giddi A)": [
    "172.18.0.100",
    "172.18.0.101",
    "172.18.0.102",
    "172.18.0.107",
    "172.18.0.108",
    "172.18.0.109",
    "172.18.0.110"
  ],
  "Giddi A Mine Entry Exit": [
    "172.18.0.111",
    "172.18.0.112",
    "172.18.0.113"
  ],
  "PO Office Giddi A": [
    "172.18.0.116"
  ],
  "MTK Office - Giddi A": [
    "172.18.0.215"
  ],
  "Giddi Washery PO": [
    "172.18.0.218"
  ],
  "Manager office - Giddi A": [
    "172.18.0.115"
  ],
  "Religara  100MT WB": [
    "172.18.0.118",
    "172.18.0.119",
    "172.18.0.120"
  ],
  "New Checkpost Religara": [
    "172.18.0.122",
    "172.18.0.123",
    "172.18.0.124"
  ],
  "Giddi C Coal Stock": [
    "172.18.0.150",
    "172.18.0.151"
  ],
  "Junction (Religara)": [
    "172.18.0.152",
    "172.18.0.153"
  ],
  "Coal Stock Near PO Office - Giddi C": [
    "172.18.0.154",
    "172.18.0.155"
  ],
  "Giddi C WB": [
    "172.18.0.157",
    "172.18.0.158",
    "172.18.0.159"
  ],
  "Giddi C DDU": [
    "172.18.0.161",
    "172.18.0.162"
  ],
  "Giddi C Magzine": [
    "172.18.0.165"
  ],
  "Giddi C Checkpost": [
    "172.18.0.168",
    "172.18.0.169"
  ],
  "Unit Store Giddi C": [
    "172.18.0.171",
    "172.18.0.172"
  ],
  "PO Office Giddi C": [
    "172.18.0.223"
  ],
  "MTK Room Giddi C": [
    "172.18.0.224"
  ],
  "Rest Shelter Giddi C": [
    "172.18.0.225"
  ],
  "PO Office Control Room - Giddi C": [
    "172.18.0.204"
  ],
  "GVTC": [
    "172.18.0.174",
    "172.18.0.175",
    "172.18.0.176",
    "172.18.0.177"
  ],
  "GM Unit": [
    "172.18.0.179",
    "172.18.0.180",
    "172.18.0.181",
    "172.18.0.182"
  ],
  "Argada Cash Office": [
    "172.18.0.63",
    "172.18.0.64",
    "172.18.0.76"
  ],
  "AKC": [
    "172.18.0.198",
    "172.18.0.199",
    "172.18.0.200",
    "172.18.0.201",
    "172.18.0.202",
    "172.18.0.203"
  ],
  "Unknown": [
    "172.18.0.242",
    "172.18.0.243",
    "172.18.0.250"
  ],
  "Religara 60 MT WB": [
    "172.18.0.139",
    "172.18.0.140",
    "172.18.0.141"
  ]
},
//Kathara
{
  "GVP Colliery WB Outside": [
    "172.25.2.231"
  ],
  "GVP Checkpoint WB Outside": [
    "172.25.2.235"
  ],
  "Zero Point WB Inside": [
    "172.25.2.221"
  ],
  "GVP Colliery WB Inside": [
    "172.25.2.232"
  ],
  "GVP Checkpost WB Inside": [
    "172.25.2.234"
  ],
  "JRD Portable Cabin": [
    "172.25.2.37"
  ],
  "JRD Excavation Workshop": [
    "172.25.2.9"
  ],
  "KTA Regional Store": [
    "172.25.3.176"
  ],
  "Swang PO Office": [
    "172.25.3.50"
  ],
  "JRD WB Checkpost 1": [
    "172.25.2.15",
    "172.25.2.16"
  ],
  "Swang Magzine": [
    "172.25.2.225",
    "172.25.2.227"
  ],
  "JRD Pit Office CHP Exit": [
    "172.25.2.3"
  ],
  "JRD Pit Office CHP Entry": [
    "172.25.2.4"
  ],
  "JRD Diesel Pump": [
    "172.25.2.7",
    "172.25.2.8"
  ],
  "Govindpur Checkpost": [
    "172.25.3.7"
  ]

},
//Kuju
{
"KUJU NEW SIDING WEIGHBRIDGE 02 (RD1304 )": [
    "172.24.198.7",
    "172.24.198.8"
  ],
  "Topa COLLIERY ROAD WEIGHBRIDGE 1 (RD1302 )": [
    "172.24.198.22",
    "172.24.198.23"
  ],
  "TOPA OCP WEIGHBRIDGE 2 (RD1301 )": [
    "172.24.198.39",
    "172.24.198.40"
  ],
  "SARUBERA ENTRY GATE (CP3108 )": [
    "172.24.198.54",
    "172.24.198.55"
  ],
  "SARUBERA EXIT GATE (SARUBERA EXIT GATE (CP3109 ) )": [
    "172.24.198.60",
    "172.24.198.61"
  ],
  "KARMA ENTRY GATE (CP3102 )": [
    "172.24.198.70",
    "172.24.198.71"
  ],
  "KARMA EXIT GATE (CP3103 )": [
    "172.24.198.72",
    "172.24.198.73"
  ],
  "SARUBERA OC WB (RD1309 )": [
    "172.24.198.86",
    "172.24.198.87"
  ],
  "ELECTRONIC ROAD WB (RD1306 )": [
    "172.24.198.102",
    "172.24.198.103"
  ],
  "Karma Internal WB 2 (RD1307 )": [
    "172.24.198.119",
    "172.24.198.120"
  ],
  "KUJU NEW SIDING CHECKPOST ENTRY (CP0921 )": [
    "172.24.185.10",
    "172.24.185.11"
  ],
  "KUJU NEW SIDING CHECKPOST EXIT (CP0922 )": [
    "172.24.185.12",
    "172.24.185.13"
  ],
  "TOPA CHECKPOST ENTRY (CP0911 )": [
    "172.24.185.26",
    "172.24.185.27"
  ],
  "TOPA CHECKPOST EXIT (CP0912 )": [
    "172.24.185.28",
    "172.24.185.29"
  ]
},
//BnK
{

  "Karo PO": [
    "172.24.84.77"
  ],
  "Karo WB 9": [
    "172.24.84.80"
  ],
  "Karo WB 7": [
    "172.24.84.83"
  ],
  "Karo WB 6": [
    "172.24.84.213"
  ],
  "Karo WB 4": [
    "172.24.84.209"
  ],
  "Karo WB 2": [
    "172.24.84.142"
  ],
  "Karo WB 5": [
    "172.24.84.145"
  ],
  "Karo WB 1": [
    "172.24.84.148"
  ],
  "Karo WB 3": [
    "172.24.84.151"
  ],
  "Karo Checkpoint": [
    "172.24.84.204"
  ],
  "Karo Siding": [
    "172.24.84.86"
  ],
  "Karo pit & view point": [
    "172.24.84.161"
  ],
  "Kargali Pit": [
    "172.24.84.21"
  ],
  "Karo Stock PTZ": [
    "172.24.84.175"
  ],
  "MRSS": [
    "172.24.84.60"
  ],
  "KMP PO": [
    "172.24.85.2"
  ],
  "KMP WB 1": [
    "172.24.85.11"
  ],
  "KMP WB 2": [
    "172.24.85.14"
  ],
  "KMP WB 3": [
    "172.24.85.17"
  ],
  "KMP WB 4": [
    "172.24.85.20"
  ],
  "KMP WB 5": [
    "172.24.85.23"
  ],
  "KMP Substation": [
    "172.24.85.43"
  ],
  "Kmp Railway Siding": [
    "172.24.48.172"
  ],
  "Konar PTZ": [
    "172.24.48.164"
  ],
  "Konar Road WB": [
    "172.24.48.137"
  ],
  "KMP Workshop": [
    "172.24.85.47"
  ],
  "kmp  CCL Checkpost": [
    "172.24.85.63"
  ],
  "krg washery PO OFFICE": [
    "172.24.84.6"
  ],
  "krg washery MTK": [
    "172.24.84.9"
  ],
  "Kargali PO": [
    "172.24.84.2"
  ],
  "Bokaro po": [
    "172.24.85.130"
  ],
  "Bokaro Hospital": [
    "172.24.85.138"
  ],
  "BokaroVTC": [
    "172.24.85.133"
  ],
  "Bokaro Workshop": [
    "172.24.85.210"
  ],
  "Water Filter": [
    "172.24.86.150"
  ],
  "GM Office": [
    "172.24.86.142"
  ],
  "Rest House": [
    "172.24.86.139"
  ],
  "Phusro rail wb": [
    "172.24.185.82"
  ],
  "JRD Store / Kargali WS": [
    "172.24.84.24"
  ],
  "Jarndih siding": [
    "172.24.86.38",
    "172.24.86.39",
    "172.24.86.42"
  ],
  "Reg.Store": [
    "172.24.86.27",
    "172.24.86.32",
    "172.24.86.33"
  ],
  "DD MINES": [
    "172.24.85.202",
    "172.24.85.203",
    "172.24.85.204"
  ],
  "Washery store": [
    "172.24.84.18",
    "172.25.84.16"
  ],
  "DG SET": [
    "172.24.84.58",
    "172.24.84.59",
    "172.24.84.61",
    "172.24.84.62"
  ],
  "Washery Store": [
    "172.24.84.17"
  ]
},
//Rajrappa
{
  "Electronic Road WB Near Check-Post III (RD1503)": [
    "172.24.200.6",
    "172.24.200.7"
  ],
  "Electronic Road WB ROCP (RD1505)": [
    "172.24.200.24",
    "172.24.200.25"
  ],
  "Rajrappa ENTRY Gate (CP1101)": [
    "172.24.200.37",
    "172.24.200.38"
  ],
  "Rajrappa EXIT Gate (CP1102)": [
    "172.24.200.39",
    "172.24.200.40"
  ],
  "Electronic Road WB ROCP (RD1504)": [
    "172.24.200.56",
    "172.24.200.57"
  ],
  "Administrative Building": [
    "10.105.25.5"
  ],
  "Central Dispatch": [
    "10.105.25.13"
  ],
  "Check-Post III": [
    "10.105.132.8"
  ],
  "Unknown": [
    "10.105.132.9",
    "10.105.162.4",
    "10.105.164.5",
    "10.106.171.11"
  ]
}



    ]
  

